import { useContext } from 'react'
import { CandidateSqlSearchContext } from 'client/candidate-table-temp/contexts/CandidateSqlSearchContext'

export const useCandidateSqlSearch = () => {
    const context = useContext(CandidateSqlSearchContext)

    if (!context) {
        throw new Error(
            'useCandidateSqlSearch must be used within <CandidateSqlSearchProvider>'
        )
    }

    return context
}
